<template>
  <div>
    <b-form-input
      class="text-uppercase"
      :id="id"
      v-model="localValue"
      v-validate="{ required: false, regex: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i }"
      name="Codice Fiscale"
      :state="stateValidation('Codice Fiscale')"
      aria-describedby="input-fiscalcode-feedback"
      autocomplete="off"
      @input="onChange"
    />
    <b-form-invalid-feedback id="input-fiscalcode-feedback">
      {{ veeErrors.first('Codice Fiscale') }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>

export default {
  name: "FiscalCode",
  props: ['value', 'id'],
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('valueChanged', newValue)
      }
    }
  },
  methods: {
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    onChange(value) {
      this.localValue = value.toUpperCase()
    }
  }
}
</script>
